
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[pathPrefix]/[slug]/[[...route]]",
      function () {
        return require("private-next-pages/[pathPrefix]/[slug]/[[...route]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[pathPrefix]/[slug]/[[...route]]"])
      });
    }
  